export enum Consents {
    newsletter = "newsletter",
    privacyPolicy = "privacyPolicy",
    termsAndConditions = "termsAndConditions",
    loyaltyConsent = "loyaltyConsent",
}
